import { createAction } from '@reduxjs/toolkit';
import { all, takeLatest } from 'redux-saga/effects';

import {
  DeleteUsernameArgs,
  deleteUsernameMutation,
} from './deleteUsernameMutation';

export const deleteUsername = createAction<DeleteUsernameArgs>(
  'deleteUsername/deleteUsername'
);

export function* watchUsernameMutations() {
  yield all([takeLatest(deleteUsername.type, deleteUsernameMutation)]);
}
